import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { IQuoteTemplate, IQuoteTemplateCreatePayload } from "../../../types/api/quoteTemplate";
import {
  listQuoteTemplates,
  createQuoteTemplate,
  deleteQuoteTemplate,
} from "./quote-template-callbacks";

export const useQuoteTemplates = () =>
  useQuery<TResponse<IQuoteTemplate[]>, Error>({
    queryKey: [API_ENDPOINTS.QUOTE_TEMPLATE_LIST],
    queryFn: () => listQuoteTemplates().then((r) => r.data),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

export const useCreateQuoteTemplate = (options?: {
  onSuccess?: (d: IQuoteTemplate) => void;
  onError?: (e: unknown) => void;
}) => {
  const queryClient = useQueryClient();
  return useMutation<TResponse<IQuoteTemplate>, Error, IQuoteTemplateCreatePayload>({
    mutationFn: (data) => createQuoteTemplate(data).then((r) => r.data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.QUOTE_TEMPLATE_LIST] });
      options?.onSuccess?.(res.data as IQuoteTemplate);
    },
    onError: options?.onError,
  });
};

export const useDeleteQuoteTemplate = (options?: {
  onSuccess?: () => void;
  onError?: (e: unknown) => void;
}) => {
  const queryClient = useQueryClient();
  return useMutation<TResponse<null>, Error, number>({
    mutationFn: (id) => deleteQuoteTemplate(id).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.QUOTE_TEMPLATE_LIST] });
      options?.onSuccess?.();
    },
    onError: options?.onError,
  });
};
